const FeaturedProduct = function() {
    function FeaturedProduct() {
        this.load()
    }
    FeaturedProduct.prototype.load = function() {
        var _ = this;
        const featuredProductSwiper = new Swiper('.swiper-media-gallery', {
            slidesPerView: 1,
            spaceBetween: 0,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
            })
    }
    FeaturedProduct = new FeaturedProduct;
}

FeaturedProduct();


  